const portal: HTMLElement = document.createElement('div');
portal.classList.add('order-dnd-portal');
document.body.appendChild(portal);

export default portal;
